import { h } from '@atomify/jsx';
import { ButtonSquare, ButtonSquareInterface } from '@atoms/button-square/button-square';

interface ContainerInterface {
    children?: NodeList;
    classes?: string;
    centered?: string;
    variant?: 'full-height' | 'vertical' | 'default';
    options?: string;
    showFade?: boolean;
    controlMode?: 'start-end' | 'default';
    onSelect?: (index: number) => void;
}

interface ListInterface {
    children?: NodeList;
}

interface SlideInterface {
    children?: NodeList;
    classes?: string;
}

type SliderEmblaControlDirection = 'left' | 'right' | 'up' | 'down';

interface ControlInterface extends ButtonSquareInterface {
    direction: SliderEmblaControlDirection;
    controlId?: string;
    active?: boolean;
}

const Container = ({
    children,
    classes,
    centered,
    variant,
    options,
    showFade,
    controlMode,
    onSelect,
    ...attributes
}: ContainerInterface) => (
    <slider-embla
        class={`c-slider-embla ${variant && 'slider-embla--' + variant} ${classes || ''}`.trim()}
        slider-options={options}
        centered={centered}
        onSelect={onSelect}
        show-fade={showFade}
        control-mode={controlMode}
        {...attributes}>
        <div class="slider-embla__container">{children}</div>
    </slider-embla>
);

const List = ({ children, ...attributes }: ListInterface) => (
    <div class="slider-embla__slider" js-hook-slider {...attributes}>
        <div class="slider-embla__slider-inner">{children}</div>
    </div>
);

const Slide = ({ children, classes, ...attributes }: SlideInterface) => (
    <div
        class={`slider-embla__slide  ${classes || ''}`.trim()}
        {...attributes}
        role="button"
        tabIndex={0}>
        <div class="slider-embla__slide-inner">{children}</div>
    </div>
);

const Control = ({
    classes,
    direction,
    active,
    controlId,
    label,
    ...attributes
}: ControlInterface) => {
    let className = `slider-embla__control slider-embla__control--${direction}`;
    className += ` ${active && 'slider-embla__control--active'}`;
    className += ` ${classes || ''}`;

    let hook = 'js-hook-slider-control-';
    switch (direction) {
        case 'left':
        case 'up':
            hook += 'previous';
            break;
        case 'right':
        case 'down':
            hook += 'next';
            break;
    }

    return (
        <ButtonSquare
            classes={className.trim()}
            attributes={{ ['data-direction']: direction, [hook]: controlId || '' }}
            svg="icons-arrow-areas"
            hook={hook}
            {...attributes}
        />
    );
};

export default { Container, List, Slide, Control };
